package devxertech.com.pages.commons

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px

@Composable
fun UpdatedButton(
    text: String,
    onClick: () -> Unit,
    color: com.varabyte.kobweb.compose.ui.graphics.Color? = null,
    formIdToSubmit: String? = null,
    isSendButton: Boolean = false,
    isLoading: Boolean = false,
    progressIndicatorColor: com.varabyte.kobweb.compose.ui.graphics.Color.Rgb? = null
    ) {
    var isButtonHovered by remember { mutableStateOf(false) }
    val sitePalette = ColorMode.current.toSitePalette()
    Box(
        modifier = Modifier
            .width(170.px)
            .height(42.px)
            .onClick { onClick() }
            .cursor(Cursor.Pointer)
            .borderRadius(6.px)
            .onMouseEnter { isButtonHovered = true }
            .onMouseLeave { isButtonHovered = false }
            .position(Position.Relative)
            .backgroundColor(if (isButtonHovered) Colors.White else sitePalette.commonSecondaryButtonColor.rgb)
            .styleModifier {
                property("background-color", "#254D79") // base color (blue)
                property("color", "white")
                property("display", "flex")
                property("align-items", "center")
                property("justify-content", "center")
                property("font-size", "17px")
            }
    ) {
        // Overlay Box like ::before
        if (isLoading) {
            Box(
                modifier = Modifier.fillMaxWidth(),
                contentAlignment = Alignment.Center
            ) {
                devxertech.com.component.ProgressIndicator(color = progressIndicatorColor)
            }
        } else {
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .position(Position.Absolute)
                    .top(0.px)
                    .left(0.px)
                    .borderRadius(6.px)
                    .backgroundColor(if (isButtonHovered) sitePalette.bodyBackgroundSecondary.rgb else sitePalette.commonSecondaryButtonColor.rgb)
                    .zIndex(0)
                    .styleModifier {
                        property("will-change", "clip-path")
                        property(
                            "transition",
                            "clip-path 0.2s ease-in-out, opacity 0.1s ease-in-out"
                        )
                        property("opacity", if (isButtonHovered) "1" else "0.999")
                        property(
                            "clip-path",
                            if (isButtonHovered)
                                "polygon(0% 100%, 0% 0%, 100% 0%, 100% 100%)"
                            else
                                "polygon(98% 98%, 99% 98%, 99% 99%, 98% 99%)"
                        )
                    }
            )
            Box(
                modifier = Modifier
                    .size(12.px)
                    .position(Position.Absolute)
                    .bottom(0.px)
                    .right(0.px)
                    .borderRadius(2.px)
                    .backgroundColor(if (isButtonHovered) sitePalette.commonSecondaryButtonColor.rgb else sitePalette.bodyBackgroundSecondary.rgb)
                    .transform {
                        translateX(5.5.px)
                        translateY(5.px)
                    }
                    .zIndex(10)
                    .styleModifier {
                        property("opacity", if (isButtonHovered) "0" else "1")
                        property("transition", "opacity 0.0s ease")
//                    property("pointer-events", if (isButtonHovered) "none" else "auto")
                    }
            )


            SpanText(
                text,
                modifier = Modifier
                    .fontFamily(Constants.FONT_FAMILY)
                    .fontSize(17.px)
                    .letterSpacing(0.3.px)
                    .fontWeight(500)
                    .color(if (isButtonHovered) sitePalette.commonSecondaryButtonColor.rgb else sitePalette.bodyBackgroundSecondary.rgb)
                    .zIndex(1)
            )
        }
    }
}
